module.exports = __webpack_public_path__ + "static/media/nokia.647ecf51.png";